import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import StudentLayout from "../../layouts/StudentLayout";
import { Arrow } from "../../components/Icons";

const LecturePlayer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { lectureId } = useParams();
  const { title, videoUrl } = location.state || {};

  const lectureTitle = title || "Lecture";
  const secureUrl = videoUrl || "";

  return (
    <StudentLayout>
      <section className="overflow-x-hidden px-4 pb-20 pt-8 sm:px-6 sm:pt-12 lg:px-12 2xl:px-[70px] font-['Roboto']">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="inline-flex items-center justify-center text-black"
          aria-label="Go back"
        >
          <Arrow />
        </button>

        {!secureUrl ? (
          <div className="mt-10 text-center text-base text-[#6B7280]">
            Video unavailable.
            {lectureId ? (
              <p className="mt-2 text-sm">Lecture ID: {lectureId}</p>
            ) : null}
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="mt-4 text-[#FF6636] hover:underline"
            >
              Go back
            </button>
          </div>
        ) : (
          <div className="mt-6 sm:mt-10 mx-auto w-full max-w-[1200px]">
            <div className="overflow-hidden rounded-lg bg-black shadow-[0_1px_8px_0_#0000001A]">
              <video
                key={secureUrl}
                className="aspect-video w-full bg-black"
                controls
                controlsList="nodownload"
                playsInline
                preload="metadata"
                src={secureUrl}
              >
                Your browser does not support the video tag.
              </video>
            </div>

            <h1 className="mt-6 text-xl font-bold leading-snug tracking-[-1%] text-black sm:mt-8 sm:text-2xl lg:text-[28px]">
              {lectureTitle}
            </h1>
          </div>
        )}
      </section>
    </StudentLayout>
  );
};

export default LecturePlayer;
